export const parseDigitalClock = (value) => {
	const [minutesText, secondsText] = value.split(':');
	const minutes = parseInt(minutesText, 10);
	const seconds = parseInt(secondsText, 10);
	return seconds + minutes * 60;
};
